module.exports = __webpack_public_path__ + "img/favicon.45f0287.png";